import React from "react";

function Notlogin() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-semibold text-gray-800">Sorry....</h1>
        <p className="text-lg text-gray-600 mt-4">
          Please Login To see this page......
        </p>
      </div>
    </div>
  );
}

export default Notlogin;